package com.yogaaicoach

import com.yogaaicoach.common.network.ApiClient
import com.yogaaicoach.common.network.KeyEventApi
import com.yogaaicoach.pages.auth.CreateAccountViewModel
import com.yogaaicoach.pages.auth.EmailPasswordSignInViewModel
import com.yogaaicoach.pages.auth.ForgotPasswordViewModel
import com.yogaaicoach.pages.auth.LoginActionsViewModel
import com.yogaaicoach.pages.auth.firebase.FirebaseService
import com.yogaaicoach.pages.dashboard.DashboardApi
import com.yogaaicoach.pages.dashboard.DashboardViewModel
import com.yogaaicoach.pages.insights.InsightsViewModel
import com.yogaaicoach.pages.insights.data.InsightsApi
import com.yogaaicoach.pages.payment.data.PaymentApi
import com.yogaaicoach.pages.payment.ui.ManageSubscriptionViewModel
import com.yogaaicoach.pages.payment.ui.SubscriptionViewModel
import com.yogaaicoach.pages.shared.media.MediaApi
import com.yogaaicoach.pages.trainingprogram.AddNewTrainingViewModel
import com.yogaaicoach.pages.trainingprogram.TrainingProgramApi
import com.yogaaicoach.pages.trainingprogram.TrainingProgramService
import com.yogaaicoach.pages.trainingprogram.UpdateTrainingViewModel
import com.yogaaicoach.pages.workout.EditWorkoutViewModel
import com.yogaaicoach.pages.workout.WorkoutScreenViewModel
import com.yogaaicoach.pages.workout.test.TestExerciseJsViewModel
import com.yogaaicoach.pages.workout.data.ExerciseApi
import com.yogaaicoach.pages.workout.data.MediaModificationService
import com.yogaaicoach.pages.workoutresults.WorkoutResultsViewModel
import com.yogaaicoach.pages.workout.data.WorkoutApi
import com.yogaaicoach.pages.workout.data.WorkoutExerciseApi
import com.yogaaicoach.pages.workout.data.WorkoutService
import com.yogaaicoach.pages.workout.workoutOverview.ui.WorkoutOverviewViewModel
import com.yogaaicoach.user.AppViewModel
import kotlinx.coroutines.MainScope

// POC: proves the shared ViewModels (same classes used by the wasmJs/Compose UI) can be driven
// by a Kotlin/JS + React rendering layer instead. Instances are module-level singletons since
// this is a single-page POC, not a real app shell.
internal val scope = MainScope()

internal val apiClient = ApiClient()
internal val dashboardApi = DashboardApi(apiClient)
internal val keyEventApi = KeyEventApi(apiClient)
internal val firebaseService = FirebaseService()
internal val sharedAppViewModel = AppViewModel(apiClient)
internal val loginActionsViewModel = LoginActionsViewModel(keyEventApi)
internal val emailPasswordSignInViewModel = EmailPasswordSignInViewModel(firebaseService)
internal val createAccountViewModel = CreateAccountViewModel(firebaseService)
internal val forgotPasswordViewModel = ForgotPasswordViewModel(firebaseService)
internal val dashboardViewModel = DashboardViewModel(dashboardApi)
internal val trainingProgramApi = TrainingProgramApi(apiClient)
internal val trainingProgramService = TrainingProgramService(trainingProgramApi)
internal val addNewTrainingViewModel = AddNewTrainingViewModel(trainingProgramService)
internal val updateTrainingViewModel = UpdateTrainingViewModel(trainingProgramService)
internal val insightsApi = InsightsApi(apiClient)
internal val insightsViewModel = InsightsViewModel(insightsApi)
internal val paymentApi = PaymentApi(apiClient)
internal val subscriptionViewModel = SubscriptionViewModel(paymentApi)
internal val manageSubscriptionViewModel = ManageSubscriptionViewModel(paymentApi)
internal val workoutApi = WorkoutApi(apiClient)
internal val workoutExerciseApi = WorkoutExerciseApi(apiClient)
internal val exerciseApi = ExerciseApi(apiClient)
internal val mediaApi = MediaApi(apiClient)
internal val workoutService = WorkoutService(workoutApi, workoutExerciseApi, mediaApi, exerciseApi)
internal val testExerciseViewModel = TestExerciseJsViewModel(workoutService)
internal val editWorkoutViewModel = EditWorkoutViewModel(workoutService)
internal val workoutOverviewViewModel = WorkoutOverviewViewModel(workoutService, scope)
internal val mediaModificationService = MediaModificationService()
internal val workoutScreenViewModel = WorkoutScreenViewModel(workoutService, mediaModificationService, scope)
internal val workoutResultsViewModel = WorkoutResultsViewModel(workoutService, scope)
